<template>

  <div class="wrap">
  
    <Nav :activeId="activeId" />  

    <div class="page-banner">
        <!-- swiper start -->
        <div class="index-section-swiper">
          <div class="index-swiper-container" ref="interSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
                  <!-- <div class="img"><img :src="item.img" class="" alt="" /></div> -->
                  <div class="img">
                    <img :src="item.img" class="" alt="" />
                    <!-- <div class="mask">
                      <img src="../../img/news/mask-bg.png" /> -->
                      <div class="layer">
                        <div class="title">{{ item.title }}</div>
                        <div class="desc" v-if="item.desc">{{ item.desc }}</div>
                        <!-- <a href="javascript:;" class="btn">Read More</a> -->
                        <a :href="item.url" class="btn">Read More</a>
                      </div>
                    <!-- </div> -->
                  </div>

                </div>
              </div>
              <div class="swiper-pagination" slot="pagination"></div>

              <div class="swiper-button-prev">
                <img src="../../img/index/icon-left-big.png" />
              </div>

              <div class="swiper-button-next">
                <img src="../../img/index/icon-right-big.png" />
              </div>
          </div>
        </div>
        <!-- swiper end -->
    </div>

    <div class="section-one section-home">
      <div class="items">
        <a href="/product-supply-system"><img src="../../img/index/item/1.jpg" /></a>
        <a href="/product-drainage-system"><img src="../../img/index/item/2.jpg" /></a>
        <a href="/about"><img src="../../img/index/item/3.jpg" /></a>
        <a href="/news"><img src="../../img/index/item/4.jpg" /></a>
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
import { getSwiper } from "@/api/index";
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      swiperList: [
        // { id: 1, img: require('@/img/index/banner/s1.jpg'), title:'让"看不见"成为"可见"', desc:'', url: '/product-solution' },
        // { id: 2, img: require('@/img/index/banner/s2.jpg'), title:'绿色、安全、舒适', desc:'姶终是我们不变的选择', url: '/life' },
        // { id: 3, img: require('@/img/index/banner/s4.jpg'), title:'六维全面水管理体系', desc:'水质安全 • 用水舒心 •低碳节能', url: '/product-six-dimensional' },
        // { id: 4, img: require('@/img/index/banner/s5.jpg'), title:'班管家服务', desc:'365服务，让您不再为管道装修而烦恼', url: '/service' },
        // { id: 5, img: require('@/img/index/banner/s6.jpg'), title:'新闻中心：水启•聚势 •谋远', desc:'2023班尼戈全国经销商大会经典回顾', url: '/news' }
      ],
      activeId: 0,
      activeIndex: 0,
      index: 0
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    // 加载Swiper数据
    this.loadSwiper();
    
    // Swiper 初始化
    new Swiper(".index-swiper-container", {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: true,
      // slideToClickedSlide: true, // 放开后，可以点击任意swiper，会立马将点击的swiper居中并展示相应内容（有个坑，自己摸索，这也是我不放开的原因）
      // 显示分页
      pagination: {
        el: ".swiper-pagination",
        clickable: true, //允许分页点击跳转
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: true
      },
      on: {
        slideChange: function() {
          console.log(this.realIndex, 'realIndex', this)
        }
      }
    })
    // new Swiper(".swiper-container", {
    //   slidesPerView: 5,
    //   spaceBetween: 10,
    //   centeredSlides: false,
    //   loop: false,
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //     hideOnClick: true
    //   },
    //   on: {
    //     slideChange: function() {
    //       console.log(this.realIndex, 'realIndex', this)
    //     }
    //   }
    // })
  },
  methods: {
    loadSwiper() {
      getSwiper().then((res) => {
        console.log(res);
        this.swiperList = res.data.data;
      });
    },
    changeSwipe(type) {
      if(type == 'up') {
        this.index -= 1;
      } else if (type == 'down') {
        this.index += 1;
      }
      // this.$refs.swiper.swipeTo(this.index);
      this.$refs.swiper.swipeTo(this.activeIndex+1);
    },
    onChange (index) {
      console.log(index)
      this.activeIndex = index
    },
    goPrev() {
      this.$refs.swiper.prev();
    },
    goNext() {
      this.$refs.swiper.next();
    }
  }
};
</script>

<style scoped lang="less">
body {
  overflow-x: hidden;
}
// 默认配置
.swiper-container {
  --swiper-theme-color: #FFF;/* 设置Swiper风格 */
  --swiper-navigation-color: #FFF;/* 单独设置按钮颜色 */
  --swiper-navigation-size: 64px;/* 设置按钮大小 */
  // --swiper-navigation-size: 0 !important;
}
/* 去除默认前进后退按钮 */
.swiper-button-prev, .swiper-button-next {
  background: transparent;
  // background: red;
  width: 48px;
  height: 48px;
  // img {
  //   width: 100%;
  //   height: 100%;
  // }
}
.swiper-button-next:after, .swiper-button-prev:after {
  display: none;
}
// 首页顶部
.index-section-swiper {
  width: 100%;
  // overflow: auto;
  .index-swiper-container {
    position: relative;
    // overflow: auto;
  }
  .swiper-wrapper {
    .swiper-slide {
      user-select: none;
      text-align: center;
      transition: 300ms;
      box-sizing: border-box;
      // width: 198px;
      .img {
        width: 100%;
        // width: 198px;
        // height: 525px;
        text-align: center;
        margin: auto;
        // .mask {
        //   width: 100%;
        //   height: 100%;
          // position: absolute;
          // bottom: 0;
          .layer {
            width: 1050px;
            position: absolute;
            margin: 0 auto;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            // top: 50%;
            // left: 0;
            // right: 0;
            // bottom: 50px;
            color: #FFF;
            text-align: left;
            .title {
              font-size: 40px;
              font-weight: bolder;
              // margin-bottom: 10px;
              letter-spacing: 1px;
            }
            .desc {
              font-size: 24px;
              font-weight: bolder;
              // margin-bottom: 10px;
              margin-top: 5px;
              letter-spacing: 1px;
            }
            .btn {
              margin-top: 30px;
              width: 118px;
              height: 29px;
              line-height: 29px;
              text-align: center;
              // background-color: #013D7F;
              background-color: #013D7F;
              color: #FFF;
              font-size: 14px;
              display: inline-block;
            }
          }
        // }
        img {
          margin: auto;
          width: 100%;
          // max-width: 100%;
          height: 100%;
        }
      }
    }
  }
  .swiper-button-prev {
    left: 5%;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .swiper-button-next {
    right: 5%;
    img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
<style lang="less">
/* 小圆点的样式，需要单独写一个不带scoped属性的style标签 */
.swiper-pagination-fraction, .swiper-pagination-custom, 
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 100px;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 10px;
}
.swiper-pagination-bullet {
  // margin-left: 20px;
  width: 12px;
  height: 12px;
  border: 1px solid #FFF;
  background-color: transparent;
  opacity: 1;
  &.swiper-pagination-bullet-active {
      // width: 10px;
      // height: 10px;
      border-radius: 50%;
      background-color: #fff;
  }
}
</style>